import {Tab} from "common/components/tab/useTabs";
import {TabNameEvent} from "common/constants/events";
import {useI18n} from "common/hooks/useI18n";

export enum TabName {
    EmailUsername = "email_username",
    PhoneNumber = "phone_number",
}

export function useTabSelectorOptions(): Array<Tab<TabName>> {
    const {i18n} = useI18n();

    const tabs: Array<Tab<TabName>> = [
        {
            id: TabName.EmailUsername,
            title: i18n("login.email_label"),
            trackingEventTabName: TabNameEvent.LoginPageEmail,
        },
        {
            id: TabName.PhoneNumber,
            title: i18n("login.phone_label"),
            trackingEventTabName: TabNameEvent.LoginPagePhone,
        },
    ];

    return tabs;
}
